import React, { Component } from 'react'
import { Input, Checkbox, message, Avatar } from 'antd'
import axios from 'axios'
import { connect } from 'react-redux'
const { Search } = Input

class AddGroupMumber extends Component {
  state = {
    gapX: 0,//鼠标点击的位置
    scrollLeft: 0,//滑块左侧位置
    isMouseLeftButtonDown: false,//记录是否按下鼠标左键
    defaultCheckedList: [],
    checkedFriendList: [],//选中的好友列表

  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps !== prevState) {
      return {
        defaultCheckedList: nextProps.groupMumberList
      }
    }
    return null
  }

  getStartPosition = (event) => {
    let AddGroupMumber = document.getElementById('AddGroupMumber')
    let scrollLeft = AddGroupMumber.scrollLeft
    let gapX = event.clientX
    if (event.button === 0) {
      this.setState({
        gapX,
        scrollLeft,
        isMouseLeftButtonDown: true
      })
    }
    return false
  }

  clearEvnet = () => {
    this.setState({
      isMouseLeftButtonDown: false
    })
  }

  setPosition = (event, gapX, scrollLeft) => {
    if (this.state.isMouseLeftButtonDown) {
      let left = event.clientX - gapX
      document.getElementById('AddGroupMumber').scrollLeft = (scrollLeft - left)
    }
    return false
  }

  checkedMumber = (event, checkedId) => {
    const checkedFriend = this.props.friendList.find(item => item.userId === checkedId)
    let frientArray = this.state.checkedFriendList
    if (event.target.checked) {
      frientArray.push(checkedFriend)
      this.setState({
        checkedFriendList: frientArray
      })
    } else {
      let index = frientArray.indexOf(checkedFriend)
      frientArray.splice(index, 1)
      this.setState({
        checkedFriendList: frientArray
      })
    }
  }

  AddGroupFriend = async () => {
    const { data: res } = await axios.post(`${window.serviceUrl.chat}/group/${this.props.activeRoom.receiverId}/member/savebybatch`, this.state.checkedFriendList)
    if (res.code === '200') {
      this.props.close()
      this.props.reloadTheGroupMumberList()
      message.success('成员添加成功')
    } else {
      message.error('成员添加失败')
    }
  }

  render() {
    return (
      <div className="add-group-mumber-panel">
        <Search className="add-group-mumber-search" placeholder="搜索"></Search>
        <div
          id='AddGroupMumber'
          className="add-group-mumber-img-slide-wrapper"
          onMouseDown={(event) => this.getStartPosition(event)}
          onMouseMove={(event) => { this.setPosition(event, this.state.gapX, this.state.scrollLeft) }}
          onMouseUp={this.clearEvnet}
          onMouseEnter={this.clearEvnet}
          onMouseLeave={this.clearEvnet}
        >
          {
            this.state.checkedFriendList && this.state.checkedFriendList.map((item) => {
              return (
                <div key={item.userId} className="add-group-mumber-img-wrapper">
                  <Avatar className="add-group-mumber-avatar" src={global.yunguanChangeUrl + item.avatar}></Avatar>
                  <div className="add-group-mumber-chatname">{item.userName}</div>
                </div>
              )
            })
          }
        </div>
        <div className="add-group-mumber-dividing-line"></div>
        <div className="add-group-mumber-chose-area">
          {
            this.props.friendList.map((item) => {
              return (
                <Checkbox
                  disabled={this.state.defaultCheckedList.some((mumber) => {
                    return mumber.userId === item.userId
                  })}
                  onChange={(event) => this.checkedMumber(event, item.userId)}
                  key={item.userId}

                  className={this.state.defaultCheckedList.some((mumber) => {
                    return mumber.userId === item.userId
                  }) ? "add-group-mumber-checked" : "add-group-mumber-checkbox"}
                >
                  <Avatar className="add-group-mumber-checkbox-avatar" src={global.yunguanChangeUrl + item.avatar} />
                  <div className="add-group-mumber-name">{item.userName}</div>
                </Checkbox>
              )
            })
          }
        </div>
        <div className="add-group-mumber-dividing-line"></div>
        <div className="add-group-mumber-footer">
          <div className="add-group-mumber-cancel" onClick={() => this.props.close()}>取消</div>
          <div className="add-group-mumber-increase" onClick={() => this.AddGroupFriend()}>添加成员({this.state.checkedFriendList.length})</div>
        </div>
      </div>
    )
  }
}

const mapState = state => ({
  friendList: state.userReducer.get('friendList').toJS(),
  activeRoom: state.userReducer.get('activeRoom')
})

export default connect(mapState)(AddGroupMumber)